import { useParams } from 'react-router-dom';
import { QuoteFlowDomainParams } from 'store/flows/quote/quoteFlowDelegate';

export const useQuoteDomainParams = (): QuoteFlowDomainParams => {
  const { groupId, periodId, cartId } = useParams<{ groupId: string; periodId: string; cartId: string }>();
  if (!groupId || !periodId || !cartId) {
    throw new Error(
      `useQuoteAddEmployeesParams: missing URL params. groupId=${groupId}, periodId=${periodId}, cartId=${cartId}`,
    );
  }
  return { groupId, periodId, cartId };
};
